let record = {
  path: "record",
  name: "record",
  component: () => import("@/views/record/index.vue"),
  meta: {
    name: "验券",
  },
};

export default record;
